<ul class="resume-list">
  <div class="resume-header">
    <label>{{ "workorder.details.visits-day" | translate }}</label>
    <label>{{ "workorder.details.visits-employee" | translate }}</label>
    <label>{{ "workorder.details.visits-hours" | translate }}</label>
  </div>
  <div class="visits-by-day">
    <li
      *ngFor="let visitsByDay of employeeVisitsDetail$ | async"
      (click)="visitsByDay.showDetail = !visitsByDay.showDetail"
    >
      <label>{{ visitsByDay.day | localizedDate : "dd MMMM, yyyy" }}</label>
      <label>{{ visitsByDay.employeeNames }}</label>
      <label>{{ visitsByDay.totalHours }}</label>
      <mat-icon
        >{{
          !visitsByDay.showDetail ? "keyboard_arrow_down" : "keyboard_arrow_up"
        }}
      </mat-icon>

      <div class="employee-container" *ngIf="visitsByDay.showDetail">
        <span
          class="employee-visits"
          *ngFor="let visitsByEmployee of visitsByDay.visitsByEmployee"
        >
          <label class="employee-name">{{
            visitsByEmployee.employeeAbbreviatedName
          }}</label>
          <label class="visit-times">
            <span *ngFor="let visit of visitsByEmployee.employeeVisits">
              {{ visit.startDate | date : "HH:mm" }} -
              {{ visit.endDate | date : "HH:mm" }}
            </span>
          </label>
        </span>
      </div>
    </li>
  </div>

  <div class="total-hours-container">
    <label>Total</label>
    <label class="total-hours">{{ totalHoursEmployeeVisits$ | async }} h</label>
  </div>
</ul>
